import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { ILocationState, LocationState } from "../types/location.types";

const initialState: LocationState = {
	location: {
		locationAddressId: 0,
		locationName: "",
		contactEmail: "",
		contactNumber: "",
		iconURL: "",
		pwuserid: 0,
		appInfo: {},
		applicationType: 0,
	},
	loading: false,
	error: null,
	uploadUrl: "",
	isLocationNotFound: false,
};

const locationSlice = createSlice({
	name: "location",
	initialState,
	reducers: {
		getLocationRequested: (state, action) => {
			state.loading = true;
			state.error = null;
		},
		getLocationSuccess: (state, action: PayloadAction<ILocationState>) => {
			state.loading = false;
			state.location = action.payload;
			state.error = null;
			state.isLocationNotFound = !action.payload?.pwuserid || !action.payload?.locationAddressId;
		},
		getLocationFailure: (state, action: PayloadAction<any>) => {
			state.loading = false;
			state.error = action.payload;
			state.isLocationNotFound = true;
		},
		updateUploadUrl: (state, action: PayloadAction<string>) => {
			state.uploadUrl = action.payload;
		},
	},
});

export const {
	getLocationSuccess,
	getLocationRequested,
	getLocationFailure,
	updateUploadUrl,
} = locationSlice.actions;

export default locationSlice.reducer;
